import React from 'react';

import RichText from '@elements/RichText';

import './style.css';

type CardVideoProps = {
  content: {
    raw: string,
  },
};

const CardVideo = ({
  content,
}: CardVideoProps): JSX.Element => (
  <div className="card--video">
    <RichText
      bodyRichText={content}
      classes="card--video__inner"
    />
  </div>
);

export default CardVideo;
